/**
 * Fired when a new sheet is being shown.
 * @event SHOW_SHEET_EVENT
 * @property {Autodesk.Viewing.Model} model - The model (sheet) that is being shown.
 */
module.exports.SHOW_SHEET_EVENT = 'showSheet';

/**
 * Fired when a sheet is being hidden.
 * (Note: when we switch to showing a different sheet, the hide event of the current sheet is fired before the next show event)
 * @event HIDE_SHEET_EVENT
 * @property {Autodesk.Viewing.Model} model - The model (sheet) that is being hidden.
 */
module.exports.HIDE_SHEET_EVENT = 'hideSheet';